module.exports = __webpack_public_path__ + "static/media/slide-1.cc951be6.jpg";